<template>
  <Dialogs :dialog="dialog" :handleClose="close">
    <template #content>
      <div class="dialog_content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item v-if="!singleEditing" id="time" label="参与日期" prop="payTimeStart" class="inlinitem">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.payTimeStart" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="!singleEditing" class="inlinitem" prop="payTimeEnd">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.payTimeEnd" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-row v-if="singleEditing">
            <el-col :span="9">          
              <el-form-item label="参与日期" prop="title">
                <div>{{ form.payTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="7">          
              <el-form-item label="姓名" prop="title">
                <div>{{ form.planterName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">          
              <el-form-item label="手机号" prop="title">
                <div>{{ form.phone }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="singleEditing">
              <el-form-item label="支付金额" prop="title">
                <div>{{form.plantingAmount}}元</div>
              </el-form-item>
          </el-row>
          <el-form-item label="植树图片" :required="true" class="uploader">
            <div style="display: flex;">
              <el-upload class="avatar-uploader" action="" ref="upload"
                :file-list="fileList" :limit="5" :before-upload="beforeAvatarUpload"                 
                :http-request="customUpload"
                :on-remove="deleteFile"
                :disabled="data.title == '详情'"
                list-type="picture"
                >
                <el-button class="upCss" size="small" v-if="data.title != '详情'">上传文件</el-button>
                <div slot="tip" class="el-upload__tip" v-if="data.title != '详情'">
                  <span>仅支持.png,.jpg,.jpge的文件上传</span>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="树苗名称" prop="treeName">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="100" v-model="form.treeName"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="植树介绍" prop="summary">
            <el-input :disabled="data.title == '详情'" style="width:405px;" type="textarea"
            :rows="4" v-model="form.summary"
              placeholder="请输入"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="showBtn">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </template>
  </Dialogs>
</template>
<script>
import { treeEdit, treeSave, fileUpload } from "@/api/api"
import Dialogs from "@/components/dialogs/dialogs.vue"
import screen from '../../../../utils/Screen' //自定义v-screen 指令




export default {
  props: ['dialog', 'handleClose', 'isView', 'formData','singleEditing'],

  directives: { screen },
  data() {
    return {
      data: {
        size: 720,
        visible: true,
        title: "新增",
      },
      loading: false,
      close: function () { },
      showBtn: false,
      // 提交表单
      form: {
        payTimeStart: "", // 时间
        payTimeEnd: "", // 时间
        treeName: "",//树苗名称
        productName: "",//树苗介绍
        accessory: ''//附件
      },
      files:[],
      fileId:[],
      // 文件列表
      fileList:[],
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeEnd) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeStart) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 校验
      rules: {
        payTimeStart: [
          { required: true, message: "请选择开始时间", trigger: 'change' },
        ],
        payTimeEnd: [
          { required: true, message: "请选择结束时间", trigger: 'change' }
        ],
        treeName: [
          { required: true, message: "请输入树苗名称", trigger: 'blur' },
        ],
        summary: [
          { required: true, message: "请输入树苗介绍", trigger: 'blur' },
        ],

      },
      files: [],

    }
  },

  mounted() {

  },
  methods: {

    // 提交
    async submitForm(){
      if(this.files.length==0&&this.fileList.length==0){
          this.$message.error('请上传至少一张图片')
          return false
        }
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if(bol){
        if (this.files.length) {
          for (let i = 0; i < this.files.length; i++) {
            await this.upload(this.files[i]);
          }
        }
        if(this.form.accessory||this.fileId.length)
          this.form.accessory = JSON.stringify(this.fileList)

        if(this.singleEditing){
          const res = await treeEdit(this.form)
          if(res.data.code == 200){
            this.data.visible = false
            this.$parent.getList()
            this.$message.success(res.data.message);
            this.fileId = []
            this.fileList = []
            this.files = []
          }else this.$message.error(res.data.message);
        }else{
          let form={...this.form}
          if(form.payTimeStart){
            form.payTimeStart=form.payTimeStart+' 00:00:00'
          }
          if(form.payTimeEnd){
            form.payTimeEnd=form.payTimeEnd+' 23:59:59'
          }
          const res = await treeSave(form)
          if(res.data.code == 200){
            this.data.visible = false
            this.$parent.getList()
            this.$message.success(res.data.message);
            this.fileId = []
            this.fileList = []
            this.files = []
          }else this.$message.error(res.data.message);
        }

      }
    },
    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      let isJPG
      isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type == "image/jpg"
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isJPG) {
        this.$message.error(
          "仅支持.png,.jpg,.jpge,格式的文件"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 200MB!");
      }
      return isJPG && isLt2M;
    },
    //自定义上传
    customUpload(file) {
      this.files.push(file.file);
    },
     //移除文件的钩子
    deleteFile(file) {
      this.fileList = this.fileList.filter((item) => item.id !== file.id);
      this.fileId.push(file.id);
    },
    //开始上传的函数
    async upload(file) {
      const searchParam = JSON.stringify({
        creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
        creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
        filename: "",
      });
      const loading = this.$loading({
        lock: true,
        text: "正在上传文件...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("searchParam", searchParam);
      const res = await fileUpload(formData);

      if (res.data.code == 200) {
        loading.close();
        this.fileList.push({
          url: res.data.data[0].fileVisitPath,
          id: res.data.data[0].id,
          name: res.data.data[0].fileOldName,
          type: res.data.data[0].fileType,
        });
        this.form.accessory = [{
          url: res.data.data[0].fileVisitPath,
          id: res.data.data[0].id,
          name: res.data.data[0].fileOldName,
          type: res.data.data[0].fileType,
        }]
      }else loading.close();
    },
    // 删除文件id
    async deleteidFile(id) {
      const res = await removeFileById(id);
      if(res.data.code == 200){
        // this.$message(res.data.message);
        this.$parent.getList()
      }else{
        // this.$message(res.data.message);
      }
    },
  },
  components: {
    Dialogs,
    
  },
  watch: {
    dialog: {
      handler(val) {
        this.$set(this, 'data', val)
      },
      immediate: true
    },
    handleClose: {
      handler(val) {
        this.$set(this, 'close', val)
      },
      immediate: true
    },
    isView: {
      handler(val) {
        this.$set(this, 'showBtn', val)
      },
      immediate: true
    },
    formData:{
      handler(val){
        this.fileList = []
        if(val.accessory){
          this.fileList = val.accessory
        }
        this.$set(this,'form',val)
        this.$nextTick(()=>{
          if(this.$refs.form)
          this.$refs.form.clearValidate();
        })
      },
    },
  }
}
</script>
<style scoped>
::v-deep .inlinitem.el-form-item {
  display: inline-flex;
  justify-content: flex-start;
}

::v-deep .inlinitem.el-form-item .el-form-item__content {
  margin-left: 2px !important;
}

.h120 {
  height: 120px;
}

::v-deep .h120 .el-textarea__inner {
  height: 120px;
}

.detail_theme {
  margin: 16px 0;
  font-size: 24px;
  text-align: center;
  color: #333;
}

.detail_content {
  margin-bottom: 20px;
  font-size: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: '微软雅黑';
  color: #333;
}

.detail_file a {
  color: #409EFF;
  text-decoration: none;
}

.detail_file img,
.detail_file video {
  width: 100%;
  display: block;
}

.detail-file-item {
  margin-bottom: 20px;
}

.file-preview {
  display: flex;
  align-items: flex-start;
  margin-left: 10px;
}

.delete-button {
  background-color: transparent;
  color: rgb(8, 8, 8);
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  z-index: 10;
}

.delete-button:hover {
  background-color: transparent;
}

/* ::v-deep .ql-container .ql-snow {
  height: 100%;
} */

::v-deep .ql-editor {
  border-color: #ccc;
  /* height: 125px !important; */
  height: 125px;
  /* height: 100% ; */
  overflow: auto;
}
</style>
